import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from "../../providers/auth/auth";
import { User } from '../../models/user.model';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { ProfilePage } from '../profile/profile';

@IonicPage()
@Component({
  selector: 'page-profile-edit',
  templateUrl: 'profile-edit.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ProfileEditPage {

  user: User;
  err: string;
  loading: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public authProvider: AuthProvider) {}

  getProfile() {
    this.loading = true;
    this.authProvider.profile()
      .subscribe(
        user => this.user = new User(user),
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  save() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      email: this.user.email,
      lastname: this.user.lastname,
      firstname: this.user.firstname,
      password: this.user.password,
      password_conf: this.user.password_conf
    }

    this.authProvider.update(values)
      .subscribe(
        user => this.navCtrl.setRoot(ProfilePage),
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_PROFILE_UPDATE'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_PROFILE_UPDATE'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        }
      );
  }

  ionViewDidLoad() {
    this.getProfile();
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile-edit/profile-edit.ts